import { Calendar, ArrowRight } from "lucide-react";
import { getImageUrl } from "../lib/utils";
import { useTranslation } from "../i18n/LanguageContext";

const NewsSection = ({ news }) => {
  const { lang, t } = useTranslation();

  if (!news || news.length === 0) return null;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(lang === "en" ? "en-GB" : "fr-FR", { day: "numeric", month: "long", year: "numeric" });
  };

  return (
    <section id="actualites" className="py-24 bg-[#0B1121]" data-testid="news-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-[#00CCC2] mb-4">{t("news_label")}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            <span className="gradient-text">{t("news_title")}</span>
          </h2>
          <p className="mt-4 text-slate-400 max-w-2xl mx-auto">{t("news_subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.slice(0, 3).map((article, index) => (
            <article key={article.id} className="group rounded-2xl bg-[#131B2F] border border-white/10 overflow-hidden card-hover" data-testid={`news-card-${index}`}>
              {article.image_url && (
                <div className="relative h-48 overflow-hidden">
                  <img src={getImageUrl(article.image_url)} alt={article.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#131B2F] to-transparent" />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-slate-400 mb-3">
                  <Calendar className="w-4 h-4" />
                  <span>{formatDate(article.created_at)}</span>
                </div>
                <h3 className="text-xl font-semibold mb-3 group-hover:text-[#00CCC2] transition-colors">{article.title}</h3>
                <p className="text-slate-400 mb-4 line-clamp-3">{article.excerpt}</p>
                <button className="flex items-center gap-2 text-[#00CCC2] font-medium group/btn">
                  {t("news_read_more")}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
